import { getChartColor } from '@modules/charts/utils';
import { ThemeMode } from '@modules/theme/constants';
import { useTheme } from '@mui/system';
import { useCallback } from 'react';
import { FieldNames } from 'v2/core/entities/fields';
import { getSentimentColor } from '../utils';

interface useGetColorOptions {
  fieldName?: FieldNames;
}

export function useGetColor({ fieldName }: useGetColorOptions = {}) {
  const theme = useTheme();

  const isLightMode = theme.palette.mode === ThemeMode.LIGHT;

  return useCallback(
    (index: number, sentiment: string): string => {
      if (
        fieldName === FieldNames.ReviewSentiment ||
        fieldName === FieldNames.EntitySentiment
      ) {
        return (
          getSentimentColor(sentiment) || getChartColor(index, isLightMode)
        );
      }

      return getChartColor(index, isLightMode);
    },
    [fieldName, isLightMode],
  );
}
